import { render, staticRenderFns } from "./BuildingSelectMenu.vue?vue&type=template&id=2f775c8c&scoped=true&"
import script from "./BuildingSelectMenu.vue?vue&type=script&lang=js&"
export * from "./BuildingSelectMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f775c8c",
  null
  
)

export default component.exports